/* eslint-disable react/prop-types */
import React, { useState } from "react";
import T from "i18n-react";
import {
    Typography,
    IconButton,
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";

const LoginDialog = props => {
    const { classes, onSignUp, onLogin, workspaceStatus, isOpen, onClose } = props;

    const [state, setState] = useState({
        isLoginForm: false,
        companyName: "",
        email: "",
        password: "",
    });

    function handleChange(e) {
        setState({
            ...state,
            [e.target.id]: e.target.value,
        });
    }

    return (
        <Dialog open={isOpen} disableBackdropClick disableEscapeKeyDown maxWidth="xs">
            {!state.isLoginForm
                ? [
                    <DialogTitle className={classes.dialogTitle} key={0}>
                        <Typography className={classes.title}>
                            {T.translate("inspectionJobWorkspace.quickForm.signUpTitle")}
                        </Typography>
                        <Typography className={classes.subTitle}>
                            {T.translate("inspectionJobWorkspace.quickForm.signUpSubTitle")}
                        </Typography>
                        <IconButton
                                aria-label="Close"
                                className={classes.dialogCloseButton}
                                onClick={() => {
                                    onClose(false);
                                }}
                            >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>,

                    <DialogContent className={classes.dialogContent} key={1}>
                        <TextField
                                id="companyName"
                                autoFocus
                                margin="dense"
                                label={T.translate("inspectionJobWorkspace.quickForm.companyName")}
                                type="text"
                                onChange={handleChange}
                                value={state.companyName}
                                fullWidth
                            />
                        <TextField
                                id="email"
                                margin="dense"
                                label={T.translate("inspectionJobWorkspace.quickForm.email")}
                                type="email"
                                onChange={handleChange}
                                value={state.email}
                                fullWidth
                            />
                        <TextField
                                id="password"
                                margin="dense"
                                label={T.translate("inspectionJobWorkspace.quickForm.createPassword")}
                                type="password"
                                onChange={handleChange}
                                value={state.password}
                                fullWidth
                            />

                        <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.dialogSignUpButton}
                                onClick={() => {
                                    onSignUp(state);
                                }}
                                disabled={workspaceStatus !== "editing"}
                            >
                            {T.translate("inspectionJobWorkspace.quickForm.signUp&BookNow")}
                        </Button>
                        <Typography className={classes.dialogReminder}>
                            {T.translate("inspectionJobWorkspace.quickForm.agreeTerms")}
                        </Typography>
                        <Divider variant="middle" />
                    </DialogContent>,
                    <DialogActions className={classes.dialogActions} key={2}>
                        <div>{T.translate("inspectionJobWorkspace.quickForm.haveAccount")}</div>
                        <Button
                                onClick={() => {
                                    setState({ ...state, isLoginForm: true });
                                }}
                                color="primary"
                            >
                            {T.translate("general.login")}
                        </Button>
                    </DialogActions>,
                ]
                : [
                    <DialogTitle className={classes.dialogTitle} key={0}>
                        <Typography className={classes.title}>
                            {T.translate("inspectionJobWorkspace.quickForm.logInTitle")}
                        </Typography>
                        <IconButton
                                aria-label="Close"
                                className={classes.dialogCloseButton}
                                onClick={() => {
                                    onClose(false);
                                }}
                            >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>,

                    <DialogContent className={classes.dialogContent} key={1}>
                        <TextField
                                id="email"
                                margin="dense"
                                label={T.translate("inspectionJobWorkspace.quickForm.email")}
                                type="email"
                                onChange={handleChange}
                                value={state.email}
                                fullWidth
                            />
                        <TextField
                                id="password"
                                margin="dense"
                                label={T.translate("inspectionJobWorkspace.quickForm.password")}
                                type="password"
                                onChange={handleChange}
                                value={state.password}
                                fullWidth
                            />

                        <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.dialogLoginButton}
                                onClick={() => {
                                    onLogin({
                                        email: state.email,
                                        password: state.password,
                                    });
                                }}
                                disabled={workspaceStatus !== "editing"}
                            >
                            {T.translate("inspectionJobWorkspace.quickForm.loginIn&BookNow")}
                        </Button>
                        <Divider variant="middle" />
                    </DialogContent>,
                    <DialogActions className={classes.dialogActions} key={2}>
                        <div>{T.translate("inspectionJobWorkspace.quickForm.noAccount")}</div>
                        <Button
                                onClick={() => {
                                    setState({ ...state, isLoginForm: false });
                                }}
                                color="primary"
                            >
                            {T.translate("login.signUp")}
                        </Button>
                    </DialogActions>,
                ]}
        </Dialog>
    );
};

export default LoginDialog;
